import { useState } from "react";

type SaveStatus = "idle" | "saving" | "error";

export function useCellSave() {
  const [status, setStatus] = useState<SaveStatus>("idle");

  const runSave = async (saveFn: () => Promise<boolean>): Promise<boolean> => {
    setStatus("saving");
    const ok = await saveFn();
    setStatus(ok ? "idle" : "error");
    return ok;
  };

  return { status, runSave };
}
